<template>
    <div class="link-notfound-page">
        <div class="link-notfound-container">
            <div class="error-card">
                <div class="error-card-header">
                    <div class="error-icon">
                        <i class="fa fa-exclamation-triangle"></i>
                    </div>
                    <h1 class="error-title">Link No Longer Available</h1>
                </div>
                <div class="error-card-body">
                    <p class="error-message">
                        This link is no longer available. It may have expired or been removed.
                    </p>
                    <p class="error-hint">
                        Please contact the dental office that sent you this link to request a new one.
                    </p>
                </div>
            </div>
            <PoweredByFooter />
        </div>
    </div>
</template>

<script>
import PoweredByFooter from '@/components/PoweredByFooter.vue';

export default {
    name: "LinkNotFound",
    components: {
        PoweredByFooter
    }
}
</script>

<style scoped>
.link-notfound-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    font-family: 'Inter', 'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, sans-serif;
}

.link-notfound-container {
    width: 100%;
    max-width: 440px;
}

.error-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.error-card-header {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    padding: 32px;
    text-align: center;
}

.error-icon {
    font-size: 48px;
    color: white;
    margin-bottom: 16px;
}

.error-title {
    color: white;
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
    line-height: 1.3;
}

.error-card-body {
    padding: 32px;
    text-align: center;
}

.error-message {
    font-size: 1rem;
    color: #334155;
    line-height: 1.6;
    margin-bottom: 12px;
}

.error-hint {
    font-size: 0.9375rem;
    color: #64748b;
    line-height: 1.6;
    margin: 0;
}

@media (max-width: 480px) {
    .link-notfound-page {
        padding: 16px;
    }

    .error-card-header {
        padding: 24px;
    }

    .error-title {
        font-size: 1.25rem;
    }

    .error-card-body {
        padding: 24px;
    }
}
</style>
